module.exports = __webpack_public_path__ + "img/Newbie_Bow_01_Mage.437d10ab.png";